// note: general import
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

// note: state import
import { selectAuth, authAction, selectRegisterStep } from "state/reducer/auth";
import { selectVerify, verifyAction } from "state/reducer/verify";

// note: MUI import
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

// note: component import
import { RegisterForm } from "components/Register/RegisterForm";
import { MCSnackbarsBV2 } from "components/Reusable/Snackbar";
import { MCHorizontalLinearStepperBV1 } from "components/Reusable/Stepper";
import { ToggleColorMode } from "components/Reusable/Themes";

// note: utils import
import { builtYear } from "utils/time";
import { BimaLogoNew } from "utils/asset";
import MainCard from "components/Reusable/MainCard";
import { LazyLoadImage } from "react-lazy-load-image-component";

// note: lottie options
// const defaultOptions = {
//   loop: true,
//   autoplay: true,
//   animationData: MetroRail,
// };

function Register() {
  const dispatch = useDispatch();

  // note: declare state
  const register = useSelector(selectAuth)?.register;
  const checkVerifyCode = useSelector(selectVerify)?.checkVerifyCode;
  const reSendVerifyCode = useSelector(selectVerify)?.sendVerifyCode;
  const fillBiodata = useSelector(selectAuth)?.fillBiodata;
  const registerStep = useSelector(selectRegisterStep);

  // note: handle close notification
  function handleCloseNotification(_, reason) {
    if (reason === "clickaway") {
      return;
    }
    register?.isFulfilled && dispatch(authAction.setClearRegister());

    register?.isRejected && dispatch(authAction.setClearRegister());

    checkVerifyCode.isFulfilled &&
      dispatch(verifyAction.setClearCheckRegisterVerifyCode());

    checkVerifyCode?.isRejected &&
      dispatch(verifyAction.setClearCheckRegisterVerifyCode());

    reSendVerifyCode?.isFulfilled &&
      dispatch(verifyAction.setClearReSendRegisterVerifyCode());

    reSendVerifyCode?.isRejected &&
      dispatch(verifyAction.setClearReSendRegisterVerifyCode());
    fillBiodata?.isFulfilled && dispatch(authAction.setClearFillBiodata());

    fillBiodata?.isRejected && dispatch(authAction.setClearFillBiodata());
  }

  // note: handle register steps
  const steps = ["Register Data", "Verify Account", "Fill Biodata"];

  return (
    <Box component={"section"}>
      <Stack
        direction={"row"}
        divider={<Divider orientation="vertical" flexItem />}
      >
        {/* note: left side */}
        <Box component={"section"} sx={{ width: "65%", height: "100vh" }}></Box>

        {/* note: right side */}
        <Box component={"section"} sx={{ width: "35%", padding: 4 }}>
          <Stack
            spacing={8}
            sx={{
              height: "100%",
              justifyContent: "center",
            }}
          >
            {/* note: form login section */}
            <Box component={"section"}>
              <Stack spacing={8}>
                <Box component={"section"} sx={{ padding: "0 2rem" }}>
                  <Stack spacing={1}>
                    <LazyLoadImage
                      alt="logo"
                      height="52px"
                      // effect={effect}
                      src={BimaLogoNew} // use normal <img> attributes as props
                      width="52px"
                      style={{
                        padding: "1px",
                        border: "1px solid white",
                        borderRadius: "10px",
                      }}
                    />
                    <Typography variant="h4">TENANT</Typography>
                  </Stack>
                </Box>

                <Box component={"section"} sx={{ padding: "0 2rem" }}>
                  <Typography variant="h4" sx={{ mb: 1 }}>
                    Login
                  </Typography>
                  <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    Please enter Your details.
                  </Typography>

                  <MainCard content={false}>
                    <Box sx={{ padding: 3 }}>
                      <RegisterForm />
                    </Box>
                  </MainCard>
                  {/* <Tabs
                    sx={{
                      mb: 3,
                      "& .MuiTabs-indicator": {
                        bgcolor: "transparent",
                      },
                      backgroundColor: "#f0eff2",
                      border: "1px solid white",
                      p: 0.5,
                      borderRadius: "8px",
                    }}
                    value={valueAudit}
                    onChange={handleChangeAudit}
                    aria-label="minimalist tabs example"
                  > */}
                  {/* <Tab
                      icon={<FaSignInAlt />}
                      iconPosition="start"
                      sx={{
                        color: "#afafaf",
                        textTransform: "none",
                        fontWeight: 400,
                        fontSize: "14px",
                        borderRadius: "8px",
                        // mr: 2,
                        width: "100%",
                        minHeight: "44px",
                        transition: "background-color 0.3s ease",
                        backgroundColor: "#f0eff2",
                        // "&:hover": {
                        //   backgroundColor: "#2b2b2b",
                        // },
                        "&.Mui-selected": {
                          color: "#000",
                          fontWeight: 400,
                          borderColor: "#424243",
                          backgroundColor: "#ffffff",
                        },
                      }}
                      label={

                      }
                      {...a11yProps(0)}
                    /> */}
                  {/* <Tab
                      icon={<BiLogoGmail />}
                      iconPosition="start"
                      sx={{
                        color: "#afafaf",
                        textTransform: "none",
                        fontWeight: 400,
                        fontSize: "14px",
                        borderRadius: "8px",
                        // mr: 2,
                        width: "50%",
                        minHeight: "44px",
                        transition: "background-color 0.3s ease",
                        backgroundColor: "#f0eff2",
                        // "&:hover": {
                        //   backgroundColor: "#2b2b2b",
                        // },
                        "&.Mui-selected": {
                          color: "#000",
                          fontWeight: 400,
                          borderColor: "#424243",
                          backgroundColor: "#ffffff",
                        },
                      }}
                      label={
                        <Box display="flex" alignItems="center">
                          <span>Sign Up</span>
                        </Box>
                      }
                      {...a11yProps(1)}
                    /> */}
                  {/* </Tabs> */}
                  {/* <TabPanel value={valueAudit} index={0}></TabPanel> */}
                  {/* <TabPanel value={valueAudit} index={1}>
                    <MainCard content={false}>
                      <Box sx={{ padding: 3 }}>
                        <RegisterForm />
                      </Box>
                    </MainCard>
                  </TabPanel> */}
                </Box>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Stack>

      {/* note: snackbars similar to toast & What is BIM */}
      <Box component={"section"}>
        {/* note: toast */}
        <MCSnackbarsBV2
          open={
            register.isFulfilled ||
            register?.isRejected ||
            checkVerifyCode?.isFulfilled ||
            checkVerifyCode?.isRejected ||
            reSendVerifyCode?.isFulfilled ||
            reSendVerifyCode?.isRejected ||
            fillBiodata?.isFulfilled ||
            fillBiodata?.isRejected
          }
          severity={
            (register.isFulfilled && "success") ||
            (register?.isRejected && "error") ||
            (checkVerifyCode?.isFulfilled && "success") ||
            (checkVerifyCode?.isRejected && "error") ||
            (reSendVerifyCode?.isFulfilled && "success") ||
            (reSendVerifyCode?.isRejected && "error") ||
            (fillBiodata?.isFulfilled && "success") ||
            (fillBiodata?.isRejected && "error") ||
            ""
          }
          handleClose={handleCloseNotification}
          message={
            (register.isFulfilled && register?.data?.message) ||
            (register?.isRejected && register?.err) ||
            (checkVerifyCode.isFulfilled && checkVerifyCode?.data?.message) ||
            (checkVerifyCode?.isRejected &&
              JSON.parse(checkVerifyCode?.err)?.message) ||
            (reSendVerifyCode.isFulfilled && reSendVerifyCode?.data?.message) ||
            (reSendVerifyCode?.isRejected &&
              JSON.parse(reSendVerifyCode?.err)?.message) ||
            (fillBiodata?.isFulfilled && fillBiodata?.data?.message) ||
            (fillBiodata?.isRejected && fillBiodata?.err) ||
            ""
          }
          autoHideDuration={3000}
        />
      </Box>
    </Box>
  );
}

export default Register;
